<div class="fullpage bg-primary">
    <div class="container d-flex h-100">
        <div class="row align-items-center mx-auto loadercontainer">
            <div class="loaderbox">
                <div class="loader"></div>
                <div class="loadtext text-primary-inverse">Logging in</div>
            </div>
        </div>
    </div>
</div>